import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import Alert from '@material-ui/lab/Alert';
import {
  withStyles,
  Typography,
} from '@material-ui/core';
import CircularProgress from 'components/shared/CircularProgress';
import PATHS from 'constants/paths';

const styles = (theme) => ({
  wrap: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(2),
    },
  },
  content: {
    textAlign: 'center',
    '& a': {
      textDecoration: 'none',
      color: '#448aff',
    },
  },
  coreIdContainer: {
    height: '50vh',
    '& iframe': {
      width: '100%',
      height: '100%',
    },

    [theme.breakpoints.up('md')]: {
      height: '55vh',
    },

    [theme.breakpoints.up('sm')]: {
      height: '65vh',
    },

    [theme.breakpoints.up('xs')]: {
      height: '65vh',
    },
  },
  paddingLeft: {
    paddingLeft: '20px',
  },
  bold: {
    fontWeight: 'bold',
  },
});

const BankIdLogin = (props) => {
  const {
    classes,
    error,
    missmatch,
    errors,
    isLoading,
  } = props;

  if (missmatch) {
    const name = errors.find((e) => e.field === 'first_name');
    const surname = errors.find((e) => e.field === 'last_name');
    const birthday = errors.find((e) => e.field === 'birthday');

    return (
      <div className={classes.wrap}>
        <div className={classes.content}>
          <Alert severity="error" elevation={6}>
            <Typography component="div" align="left">
              <FormattedMessage
                id="bankId.informationMissmatch"
                defaultMessage="The information from your profile does not match the information provided by BankID."
              />
            </Typography>
            {
              !!name && (
                <Typography component="div" align="left">
                  <FormattedMessage
                    id="bankId.nameMissmatch"
                    defaultMessage={"Your profile's first name \"{profile}\" does not include \"{bankid}\" from BankID"}
                    values={{
                      profile: name.profile,
                      bankid: name.bankid,
                    }}
                  />
                </Typography>
              )
            }
            {
              !!surname && (
                <Typography component="div" align="left">
                  <FormattedMessage
                    id="bankId.surnameMissmatch"
                    defaultMessage={"Your profile's last name \"{profile}\" does not include \"{bankid}\" from BankID"}
                    values={{
                      profile: surname.profile,
                      bankid: surname.bankid,
                    }}
                  />
                </Typography>
              )
            }
            {
              !!birthday && (
                <Typography component="div" align="left">
                  <FormattedMessage
                    id="bankId.birthdateMissmatch"
                    defaultMessage={"Your profile's birthdate \"{profile}\" does not match \"{bankid}\" from BankID"}
                    values={{
                      profile: birthday.profile,
                      bankid: birthday.bankid,
                    }}
                  />
                </Typography>
              )
            }
            <br />
            <Typography component="div" align="left">
              <FormattedMessage
                id="bankId.informationMissmatchLink"
                defaultMessage="{link} to correct the information and then try again"
                values={{
                  link: (
                    <Link to={PATHS.users.profile}>
                      <Typography variant="body1" component="span">
                        <FormattedMessage
                          id="Click here"
                          defaultMessage="Click here"
                        />
                      </Typography>
                    </Link>
                  ),
                }}
              />
            </Typography>
          </Alert>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={classes.wrap}>
        <div className={classes.content}>
          <Alert severity="error" elevation={6}>
            <FormattedMessage
              id="cottage.verify.error"
              defaultMessage="There was an error contacting BankID"
            />
          </Alert>
        </div>
      </div>
    );
  }

  return (
    <div className={classes.wrap}>
      <div className={classes.content}>
        {
          isLoading && <CircularProgress />
        }
        <div id="core-id-container" className={classes.coreIdContainer} />
      </div>
    </div>
  );
};

BankIdLogin.propTypes = {
  error: PropTypes.string,
  missmatch: PropTypes.bool,
  classes: PropTypes.shape({}).isRequired,
  isLoading: PropTypes.bool,
  errors: PropTypes.arrayOf(
    PropTypes.shape({
      field: PropTypes.string,
      profile: PropTypes.string,
      bankid: PropTypes.string,
    }),
  ),
};

export default injectIntl(withStyles(styles)(BankIdLogin));
